import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { ShippingCarrierUpdateInput } from "@/modules/shipping/domain/contracts";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { useCarrierQuery, useUpdateCarrier } from "../api/queries";
import { CarrierForm } from "../ui/CarrierForm";

export function CarrierEditPage() {
  const nav = useNavigate({ from: "/app/shipping/carriers/$id/edit" });
  const { id } = useParams({ from: "/app/shipping/carriers/$id/edit" });
  const { data, ...result } = useCarrierQuery(id);
  const updateCarrier = useUpdateCarrier(id);
  const carrier = data;
  const title =
    carrier && typeof carrier.name === "object" && carrier.name !== null
      ? ((carrier.name as { lo?: string })?.lo ??
        (carrier.name as { en?: string })?.en ??
        carrier.code)
      : (carrier?.code ?? id);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຜູ້ຂົນສົ່ງ", to: "/app/shipping/carriers" },
            { label: title },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">ແກ້ໄຂ</h2>
            <p className="text-muted-foreground">{carrier?.code ?? id}</p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/shipping/carriers" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <QueryState
          result={result}
          title="ກຳລັງໂຫຼດ"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!carrier ? null : (
            <div className="mt-6 rounded-xl border bg-card p-6">
              <CarrierForm
                initialValues={{
                  code: carrier.code,
                  nameLo: (carrier.name as { lo?: string })?.lo ?? "",
                  nameTh: (carrier.name as { th?: string })?.th ?? "",
                  nameEn: (carrier.name as { en?: string })?.en ?? "",
                  enabled: carrier.enabled,
                  sortOrder: carrier.sortOrder,
                }}
                onSubmit={async (values: ShippingCarrierUpdateInput) => {
                  await updateCarrier.mutateAsync(values);
                  nav({ to: "/app/shipping/carriers" });
                }}
                onCancel={() => nav({ to: "/app/shipping/carriers" })}
                submitting={updateCarrier.isPending}
              />
            </div>
          )}
        </QueryState>
      </Main>
    </>
  );
}
